import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import _isEqual from 'lodash/isEqual';

import { Checkbox } from '../../../utilites';
import LoaderDetails from './LoaderDetails/LoaderDetails';

import './witndrawalInwentoryDetails.scss';

const WitndrawalInwentoryDetails = memo(({ tn, transferId, isTabLoading, handleContractCheck }) => {
  const check = tn?.deal && !_isEqual(tn.deal, {});

  const handleLocalContractCheck = (e) => {
    handleContractCheck(e, transferId);
  };

  return isTabLoading ? (
    <LoaderDetails />
  ) : (
    <div className="overdue-content-section">
      <table className="table hover">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">
              <p>Номер</p>
            </th>
            <th scope="col">
              <div className="witndrawalInwentoryDetails-table-body-box">
                <div className="witndrawalInwentoryDetails-table-body-box-name">
                  <p>Наименование</p>
                </div>
                <div className="witndrawalInwentoryDetails-table-body-box-quantity">
                  <p>Количество</p>
                </div>
                <div className="witndrawalInwentoryDetails-table-body-box-estimatedValue">
                  <p>
                    Оценочная <br />
                    стоимость, руб.
                  </p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {check &&
            tn.deal.deal &&
            tn.deal.deal.length !== 0 &&
            tn.deal.deal.map((i, ind) => (
              <tr key={i.id}>
                <td className="table-cellcontent">
                  <Checkbox
                    id={i.id}
                    name={i.id}
                    onChange={handleLocalContractCheck}
                    value={i.checked}
                  />
                  <p>{ind + 1}</p>
                </td>
                <td>
                  <p>
                    <Link className="table-link" to={`client/${i.clientId}/contracts/${i.id}`}>
                      <span>{i.dealNumber || i.id}</span>
                    </Link>
                  </p>
                </td>
                <td>
                  <div className="witndrawalInwentoryDetails-table-body-group">
                    {i.positions &&
                      i.positions.length !== 0 &&
                      i.positions.map((item, ind) => (
                        <div
                          className="witndrawalInwentoryDetails-table-body-box"
                          key={item.names.join() + ind}>
                          <div className="witndrawalInwentoryDetails-table-body-box-name">
                            <p>{item.names.join(' ')}</p>
                          </div>
                          <div className="witndrawalInwentoryDetails-table-body-box-quantity">
                            <p>{item.quantity}</p>
                          </div>
                          <div className="witndrawalInwentoryDetails-table-body-box-estimatedValue">
                            <p>{i.type === 'THINGS' ? (i.totalEstimatedValue).toFixed(2) : (+item.estimatedValue).toFixed(2)}</p>
                          </div>
                        </div>
                      ))}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
});

export default WitndrawalInwentoryDetails;
